var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$route.query)?_c('OptionalFeed',{attrs:{"title":this.$route.query.title,"query":{
    tagId: [Number(this.$route.query.tag_id)],
  }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }